import { render, staticRenderFns } from "./StaticErrorTemplate.vue?vue&type=template&id=1aaa5bcc&scoped=true&"
import script from "./StaticErrorTemplate.vue?vue&type=script&lang=ts&"
export * from "./StaticErrorTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./StaticErrorTemplate.vue?vue&type=style&index=0&id=1aaa5bcc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaa5bcc",
  null
  
)

export default component.exports